import React from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { TableRow, TableCell } from "@/components/ui/table";

export const MerchantReportTableSkeleton: React.FC<{ rowCount?: number }> = ({
  rowCount = 5,
}) => {
  return (
    <>
      {[...Array(rowCount)].map((_, index) => (
        <TableRow key={index} className="border-b border-gray-100">
          {/* Merchant Name */}
          <TableCell className="py-4">
            <Skeleton className="h-4 w-40" />
          </TableCell>
          {/* No. of Transactions */}
          <TableCell className="py-4">
            <Skeleton className="h-4 w-28" />
          </TableCell>
          {/* Business Amount */}
          <TableCell className="py-4">
            <Skeleton className="h-4 w-32" />
          </TableCell>
          {/* Points Accrued */}
          <TableCell className="py-4">
            <Skeleton className="h-4 w-24" />
          </TableCell>
          {/* Last Transaction Date */}
          <TableCell className="py-4">
            <Skeleton className="h-4 w-36" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
